import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { "aria-label": "페이지 탐색" };
const _hoisted_2 = ["aria-disabled", "disabled"];
const _hoisted_3 = ["aria-current", "aria-label", "onClick"];
const _hoisted_4 = ["aria-disabled", "disabled"];
import { tv } from 'tailwind-variants';
import { computed } from 'vue';
import { SpriteIcons } from '@/user/components/common/';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        page: {},
        totalPages: {}
    },
    emits: ["update:page"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const pagination = tv({
            slots: {
                wrapper: 'flex',
                item: 'rounded-4 hover:text-gray-850 text-title-4 flex size-32 items-center justify-center text-gray-600',
                arrow: 'rounded-4 flex size-32 items-center justify-center text-gray-900 hover:bg-gray-500/10 disabled:bg-transparent disabled:text-gray-400',
            },
            variants: {
                currentPage: {
                    true: {
                        item: 'bg-blue-150 text-gray-850',
                    },
                },
                arrowDisabled: {
                    true: {
                        arrow: 'text-gray-400',
                    },
                },
            },
        });
        const { wrapper, item, arrow } = pagination({});
        const pages = computed(() => {
            const maxVisiblePages = 5;
            // 총 페이지가 5개 이하인 경우 모든 페이지 표시
            if (props.totalPages <= maxVisiblePages) {
                return Array.from({ length: props.totalPages }, (_, i) => i + 1);
            }
            // 현재 페이지가 속한 그룹의 시작 페이지 계산
            const currentGroup = Math.ceil(props.page / maxVisiblePages);
            const startPage = (currentGroup - 1) * maxVisiblePages + 1;
            const endPage = Math.min(startPage + maxVisiblePages - 1, props.totalPages);
            return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
        });
        const isPrevDisabled = computed(() => props.page === 1 || props.totalPages === 1);
        const isNextDisabled = computed(() => props.page === props.totalPages || props.totalPages === 1);
        const handlePageClick = (pageNum) => {
            emit('update:page', pageNum);
        };
        const handlePrevClick = () => {
            if (!isPrevDisabled.value) {
                emit('update:page', props.page - 1);
            }
        };
        const handleNextClick = () => {
            if (!isNextDisabled.value) {
                emit('update:page', props.page + 1);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("ul", {
                    class: _normalizeClass(_unref(wrapper)()),
                    role: "navigation"
                }, [
                    _createElementVNode("li", null, [
                        _createElementVNode("button", {
                            "aria-disabled": isPrevDisabled.value,
                            "aria-label": "이전 페이지",
                            class: _normalizeClass(_unref(arrow)({
                                arrowDisabled: isPrevDisabled.value,
                            })),
                            disabled: isPrevDisabled.value,
                            type: "button",
                            onClick: handlePrevClick
                        }, [
                            _createVNode(_unref(SpriteIcons), {
                                "aria-hidden": "true",
                                class: "size-16",
                                name: "arrow-left"
                            })
                        ], 10, _hoisted_2)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (pageNum) => {
                        return (_openBlock(), _createElementBlock("li", { key: pageNum }, [
                            _createElementVNode("button", {
                                "aria-current": __props.page === pageNum ? 'page' : undefined,
                                "aria-label": `${pageNum}페이지`,
                                class: _normalizeClass(_unref(item)({
                                    currentPage: __props.page === pageNum,
                                })),
                                onClick: ($event) => (handlePageClick(pageNum))
                            }, _toDisplayString(pageNum), 11, _hoisted_3)
                        ]));
                    }), 128)),
                    _createElementVNode("li", null, [
                        _createElementVNode("button", {
                            "aria-disabled": isNextDisabled.value,
                            "aria-label": "다음 페이지",
                            class: _normalizeClass(_unref(arrow)({
                                arrowDisabled: isNextDisabled.value,
                            })),
                            disabled: isNextDisabled.value,
                            type: "button",
                            onClick: handleNextClick
                        }, [
                            _createVNode(_unref(SpriteIcons), {
                                "aria-hidden": "true",
                                class: "size-16",
                                name: "arrow-right"
                            })
                        ], 10, _hoisted_4)
                    ])
                ], 2)
            ]));
        };
    }
});
